import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImagePlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 140 104",
	fill: "none",
	preserveAspectRatio: "xMidYMid slice",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 139,
			height: 103,
			rx: 9.5,
			fill: "#E9E7E1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 139,
			height: 103,
			rx: 9.5,
			stroke: "#E5E3DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70 52L95.9808 80.5H44.0192L70 52Z",
			fill: "#C7C4BC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .7,
			d: "M91.6 60L107.708 80.52H75.4919L91.6 60Z",
			fill: "#C7C4BC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 102.2,
			cy: 27.8008,
			r: 7,
			fill: "white"
		})
	]
});
export default SvgImagePlaceholder;
